import {createRouter, createWebHashHistory} from "vue-router"

const routes = [
    {
        path: '/',
        name: "/",
        redirect: "/login"
    },
    // 登录页面
    {
        path: '/login',
        name: 'login',
        component: () => import(/*webpackChunkName:'login'*/ '@/page/login/login.vue')
    },
    // 主页面
    {
        path: '/index',
        name: 'index',
        component: () => import(/*webpackChunkName:'index'*/ '@/page/index/index.vue'),
        children: [
            // 流量监控页面
            {
                path: '/index/monitor',
                name: 'monitor',
                component: () => import(/*webpackChunkName:'monitor'*/ '@/page/monitor/monitor.vue'),
            },
            // 轮播图管理页面
            {
                path: '/index/content/banner',
                name: 'banner',
                component: () => import(/*webpackChunkName:'account'*/ '@/page/content/banner.vue'),
            },
            // 广告图管理页面
            {
                path: '/index/content/advertisement',
                name: 'advertisement',
                component: () => import(/*webpackChunkName:'account'*/ '@/page/content/advertisement.vue'),
            },
            //客户管理页面
            {
                path: '/index/custom',
                name: 'custom',
                component: () => import(/*webpackChunkName:'custom'*/ '@/page/custom/custom.vue'),
            },
            //订单管理页面
            {
                path: '/index/order',
                name: 'order',
                component: () => import(/*webpackChunkName:'order'*/ '@/page/order/order.vue'),
            },
            //商品类型管理页面
            {
                path: '/index/goods/type',
                name: 'type',
                component: () => import(/*webpackChunkName:'goods'*/ '@/page/goods/type.vue'),
            },
            //商品条目管理页面
            {
                path: '/index/goods/item',
                name: 'item',
                component: () => import(/*webpackChunkName:'goods'*/ '@/page/goods/item.vue'),
            },
            // 账号管理页面
            {
                path: '/index/account',
                name: 'account',
                component: () => import(/*webpackChunkName:'account'*/ '@/page/account/account.vue'),
            },
            // 用户管理页面
            {
                path: '/index/user',
                name: 'user',
                component: () => import(/*webpackChunkName:'user'*/ '@/page/user/user.vue'),
            },
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router